import React, { useState } from 'react';
import { TextField, Button, Typography, Paper, Box, Grid, CircularProgress } from '@mui/material';
import { changePassword } from '../api'; // Import the changePassword API call
import { useParams, useNavigate } from 'react-router-dom';

function ChangePasswordPage() {
  const [currentPassword, setCurrentPassword] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const { token } = useParams(); // Get the token from the URL
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false); // Add loading state

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      setError('Passwords do not match.');
      setMessage('');
      return;
    }

    setLoading(true); // Start loading
    setMessage(''); // Clear previous messages/errors
    setError('');

    try {
      await changePassword(currentPassword, password); // Call your changePassword API
      setMessage('Password has been changed successfully.');
      setError('');
      setTimeout(() => {
           navigate('/login');
      }, 2000); // Redirect after 2 seconds
    } catch (err) {
      setError(err.message || 'Failed to reset password.');
      setMessage('');
    }finally {
      setLoading(false); // End loading
    }
  };

  return (
    <Grid container justifyContent="center" sx={{ mt: 4 }}>
      <Grid item xs={12} sm={8} md={5} lg={4}>
        <Paper elevation={6} sx={{ p: 3 }}>
          <Typography variant="h5" align="center" gutterBottom>
            Change Password
          </Typography>
          {message && <Typography color="success" align="center" sx={{ mb: 2 }}>{message}</Typography>}
          {error && <Typography color="error" align="center" sx={{ mb: 2 }}>{error}</Typography>}
          <form onSubmit={handleSubmit}>
            <Box mb={2}>
              <TextField
                fullWidth
                label="Current Password"
                variant="outlined"
                type="password"
                value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value)}
                required
                disabled={loading} // Disable input while loading
              />
            </Box>

            <Box mb={2}>
              <TextField
                fullWidth
                label="New Password"
                variant="outlined"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                disabled={loading} // Disable input while loading
              />
            </Box>
            <Box mb={3}>
              <TextField
                fullWidth
                label="Confirm New Password"
                variant="outlined"
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
                disabled={loading} // Disable input while loading
              />
            </Box>
            <Button variant="contained" color="primary" type="submit" fullWidth
              disabled={loading} // Disable button while loading
              startIcon={loading ? <CircularProgress size={20} color="inherit" /> : null} // Show spinner
            >
              {loading ? 'Changing...' : 'Reset Password'} {/* Change text while loading */}
            </Button>
          </form>
        </Paper>
      </Grid>
    </Grid>
  );
}

export default ChangePasswordPage;